module.exports = __webpack_public_path__ + "img/tecnologia.6e712bd4.png";